export default __webpack_public_path__ + "static/media/sticker-Q.6a652867.png";